module.exports = __webpack_public_path__ + "static/img/机械开合旋转.13686ab3.png";